<template>
    <div>
        <el-container class="EnterpriseServices" :style="{ height: Height - 105 + 'px'}" v-loading.fullscreen.lock="fullscreenLoading">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>企业服务管理</h2>
                    </el-col>
                    <el-col :span="12">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="企业名称">
                                    <el-input v-model="queryform.title"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <!-- <el-button type="primary" @click="Reset">重置</el-button> -->
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddEnterpriseServices">新增</el-button>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" :height="Height - 265" border style="width: 100%">
                    <el-table-column prop="title" label="企业名称">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.type === 3" type="text" size="small" @click="Participate(scope.row)">参加人员</el-button>
                            <el-button type="text" size="small" @click="EditEnterpriseServices(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="Delete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="Administration" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Administration">
                    <el-form :model="formData" label-width="100px">
                        <el-form-item label="企业名称">
                           <el-input v-model="formData.title" placeholder="请输入企业名称"></el-input>
                        </el-form-item>
                        <el-form-item label="企业简介">
                            <el-button type="primary" @click="dialogVisible = true">点击打开 编辑器</el-button>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirm">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog
                    title="编辑器"
                    :visible.sync="dialogVisible"
                    fullscreen
                    @opened="contentShow"
                    width="80%" :close-on-click-modal="false"
                    :show-close="false" :close-on-press-escape="false" custom-class="dialogVisible">
                        <tinymce style="display: inline-block;width: 100%;" :height="Height - 300" ref="content" v-model="formData.contents"/>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="cancelcontent">取 消</el-button>
                            <el-button type="primary" @click="confirmcontent">确 定</el-button>
                        </div>
                </el-dialog>
                <el-dialog title="活动参加人员列表" custom-class="personnel" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogTableVisible">
                    <el-table :height="Height - 352" :data="personnelData" border style="width: 100%">
                        <el-table-column prop="title" label="客户名" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="mobile" label="联系电话">
                        </el-table-column>
                        <el-table-column prop="sex" label="性别">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sex === 1">男</span>
                                <span v-if="scope.row.sex === 2">女</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="company_name" label="公司名">
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-row>
                            <el-col :span="6" style="text-align: left;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizess"
                                    layout="total"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizess"
                                    layout="prev, pager, next"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                            <el-col :span="6" style="text-align: right;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizess"
                                    layout="->, sizes"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                        </el-row>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="20"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="20"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Sizes"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
        <!-- <el-button type="text" @click="dialogVisible = true">点击打开 表单</el-button> -->
    </div>

</template>


<script>
import Tinymce from "../../../components/Tinymce/index.vue";
import parser from "mini-html-parser2";
export default {
    name: "EnterpriseServices",
    data() {
        return {
            tableData: [],
            typeList: [
                {
                    label: "公告",
                    value: 1
                },
                {
                    label: "新闻",
                    value: 2
                },
                {
                    label: "活动",
                    value: 3
                }
            ],
            statusList: [
                {
                    label: "未发布",
                    value: 0
                },
                {
                    label: "发布",
                    value: 1
                },
                {
                    label: "始终发布",
                    value: 2
                }
            ],
            title: "",
            formData: {
                contents: "",
                content: "",
                title: "",
                status: 1
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            dialogVisible: false,
            Administration: false,
            total: 0,
            currentPage: 1,
            Sizes: 20,
            currentPages: 1,
            Sizess: 20,
            totals: 0,
            dialogTableVisible: false,
            personnelData: [],
            Participates: {},
            visible: false,
            queryform: {
                title: ""
            },
            fullscreenLoading: false
        };
    },
    components: {
        Tinymce
    },
    methods: {
        /*eslint-disable */
        ConfirmQuery () {
            this.currentPage = 1
            let data = {
                limit: this.Sizes,
                page: this.currentPage,
                title: this.queryform.title
            };
            this.fullscreenLoading = true
            this.$store
                .dispatch("EnterpriseServicesListShow", data)
                .then(res => {
                    this.fullscreenLoading = false
                    this.tableData = res.data;
                    this.Administration = false;
                    this.visible = false
                    this.total = res.something
                });
        },
        Participate (row) {
            // 参加人员
            this.Participates = row
            this.GetParticipate()
        },
        GetParticipate () {
            let data = {
                limit: this.Sizes,
                page: this.currentPages,
                ad_id: this.Participates.id
            };
            this.dialogTableVisible = true;
            this.$store
                .dispatch("Participate", data)
                .then(res => {
                    this.personnelData = res.data;
                    this.totals = res.something;
                });
        },
        handleSizeChanges(size) {
            this.Sizess = size
            this.GetParticipate()
        },
        handleCurrentChanges(current) {
            this.currentPages = current
            this.GetParticipate()
        },
        handleSizeChange(size) {
            console.log(size)
            this.Sizes = size
            let data = {
                limit: size,
                page: this.currentPage,
                title: this.queryform.title
            };
            this.fullscreenLoading = true
            this.$store
                .dispatch("EnterpriseServicesListShow", data)
                .then(res => {
                    this.fullscreenLoading = false
                    this.tableData = res.data;
                    this.Administration = false;
                    this.total = res.something
                });
        },
        handleCurrentChange(current) {
            console.log(current)
            this.currentPage = current
            let data = {
                limit: this.Sizes,
                page: current,
                title: this.queryform.title
            };
            this.fullscreenLoading = true
            this.$store
                .dispatch("EnterpriseServicesListShow", data)
                .then(res => {
                    this.fullscreenLoading = false
                    this.tableData = res.data;
                    this.Administration = false;
                    this.total = res.something
                });
        },
        resourceSelect(item) {
            alert(JSON.stringify(item));
        },
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then(() => {
                    done();
                })
                .catch(() => {});
        },
        AddEnterpriseServices() {
            this.title = "新增信息";
            this.Administration = true;
        },
        confirmcontent() {
            console.log(this.formData.content);
            this.formData.content = JSON.parse(JSON.stringify(this.formData.contents))
            const content = JSON.parse(JSON.stringify(this.formData.contents)).replace(/<img/gi, '<img width="100%!important" height="auto"')
            parser(content, (err, nodes) => {
                if (!err) {
                   this.formData.contentarr = JSON.stringify(nodes)
                }
            })
            this.dialogVisible = false;
        },
        cancelcontent() {
            // console.log(this.formData.content);
            // this.$refs.content.setContent("");
            // this.formData.content = "";
            this.dialogVisible = false;
        },
        cancel() {
            if (this.$refs.content) {
                this.$refs.content.setContent("");
            }
            this.formData = {
                contents: "",
                content: "",
                title: "",
                status: 1,
            };
            this.Administration = false;
        },
        confirm() {
            let that = this;
            let data = JSON.parse(JSON.stringify(this.formData));
            this.$store.dispatch("AddEnterpriseServices", data).then(res => {
                if (res.flag) {
                   that.$message({
                        message: res.message,
                        type: "success"
                    });
                    let data = {
                        limit: that.Sizes,
                        page: that.currentPage,
                        title: that.queryform.title
                    };
                    that.fullscreenLoading = true
                    that.$store
                        .dispatch("EnterpriseServicesListShow", data)
                        .then(res => {
                            that.fullscreenLoading = false
                            that.tableData = res.data;
                            that.Administration = false;
                            that.total = res.something
                            if (that.$refs.content) {
                                that.$refs.content.setContent("");
                            }
                            that.formData = {
                                contents: "",
                                content: "",
                                title: "",
                                status: 1
                            };
                        });
                } else {
                    that.$message({
                        message: res.message,
                        type: "warning"
                    });
                }
            });
        },
        Delete(row) {
            let that = this;
            this.$confirm("是否删除该公告?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$store.dispatch("DeleteEnterpriseServices", row).then(res => {
                    if (res.flag) {
                        that.$message({
                            message: res.message,
                            type: "success"
                        });
                        let data = {
                            limit: that.Sizes,
                            page: that.currentPage,
                            title: that.queryform.title
                        };
                        that.fullscreenLoading = true
                        that.$store
                            .dispatch("EnterpriseServicesListShow", data)
                            .then(res => {
                                that.fullscreenLoading = false
                                that.tableData = res.data;
                                that.Administration = false;
                                that.total = res.something
                            });
                    } else {
                        that.$message({
                            message: res.message,
                            type: "warning"
                        });
                    }
                })
            }).catch(() => {
            });
        },
        contentShow() {
            if (this.formData.content !== '') {
                this.$refs.content.setContent(this.formData.content);
            }
        },
        EditEnterpriseServices(row) {
            this.formData = JSON.parse(JSON.stringify(row));
            this.formData.contents = JSON.parse(JSON.stringify(this.formData.content))
            this.title = "编辑信息";
            this.Administration = true;
        }
    },
    mounted() {},
    created() {
        let data = {
            limit: this.Sizes,
            page: this.currentPage,
            title: this.queryform.title
        };
        this.fullscreenLoading = true
        this.$store.dispatch("EnterpriseServicesListShow", data).then(res => {
            this.fullscreenLoading = false
            this.tableData = res.data;
            this.total = res.something
        });
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height
        }
    }
};
</script>


<style type="text/scss" lang="scss">
.EnterpriseServices {
    width: 100%;
    height: 100%;
}
.EnterpriseServices .el-header h2 {
    text-align: center;
}
.EnterpriseServices .el-header .el-col {
    height: 40px;
}
.EnterpriseServices .el-header .el-col:last-child {
    text-align: right;
}
.EnterpriseServices .el-header .el-col .el-button {
    // height: 30px;
    // line-height: 30px;
    padding-top: 9px;
    padding-bottom: 9px;
}
.EnterpriseServices .el-main {
    padding-top: 0px;
    margin: 0px;
}
.EnterpriseServices .el-main .el-table tr td {
    height: 30px;
    padding-top: 0px;
    padding-bottom: 0px;
    font-size: 12px;
}
.EnterpriseServices .el-main .el-table tr th {
    text-align: center;
    height: 35px;
    color: #000;
    padding-top: 0px;
    padding-bottom: 0px;
    background-color: #f5f5f5;
}
.EnterpriseServices .el-main .Administration .el-form .el-form-item__content .el-select {
    width: 100%;
}
.EnterpriseServices .el-main .Administration .el-form .el-form-item__content .el-date-editor {
    width: 100%;
}
.EnterpriseServices .el-main .dialogVisible .el-dialog__body {
    padding-top: 0px;
}
</style>
